import useSWR from 'swr';
import { fetcher } from '../../services/fetcher';
import {
  createExpenseCategory,
  updateExpenseCategory,
  deleteExpenseCategory,
  createExpenseSubCategory,
  updateExpenseSubCategory,
  deleteExpenseSubCategory,
} from '../../services/mutations';

const API_CATEGORIES = '/crm-expense-category';
const API_SUBCATEGORIES = '/crm-expense-sub-category';

export interface ExpenseCategory {
  id: number;
  name?: string;
}

export interface ExpenseSubCategory {
  id: number;
  name?: string;
  exp_category_id?: number;
  exp_category_desc?: { id: number; name?: string };
}

export const useExpenseCategories = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<ExpenseCategory[]>(
    `${API_CATEGORIES}${queryString}`,
    fetcher,
    { revalidateOnFocus: true }
  );
  return { data: data ?? [], isLoading, isError: !!error, mutate };
};

export const useExpenseCategory = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<ExpenseCategory>(
    id ? `${API_CATEGORIES}/${id}` : null,
    fetcher,
    { revalidateOnFocus: true }
  );
  return { data: data ?? undefined, isLoading, isError: !!error, mutate };
};

export const useExpenseSubCategories = () => {
  const { data, error, isLoading, mutate } = useSWR<ExpenseSubCategory[]>(API_SUBCATEGORIES, fetcher, {
    revalidateOnFocus: true,
  });
  return { data: data ?? [], isLoading, isError: !!error, mutate };
};

export {
  createExpenseCategory,
  updateExpenseCategory,
  deleteExpenseCategory,
  createExpenseSubCategory,
  updateExpenseSubCategory,
  deleteExpenseSubCategory,
};
